import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { addAuthToken, isTokenExpired } from "../../services/api";

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  user: {
    id: number;
    username: string;
    role: string;
  } | null;
}

// Bootstrap from localStorage, but reject expired tokens so a stale token can't
// keep the UI in an authenticated (and possibly wrong-brand) state.
function bootstrapToken(): string | null {
  const token = localStorage.getItem("auth_token");
  if (!token) return null;
  if (isTokenExpired(token)) {
    localStorage.removeItem("auth_token");
    addAuthToken(null);
    return null;
  }
  return token;
}

const bootstrappedToken = bootstrapToken();

const initialState: AuthState = {
  token: bootstrappedToken,
  isAuthenticated: !!bootstrappedToken,
  user: null, // User data can be decoded from token if needed
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      const token = action.payload;
      state.token = token;
      state.isAuthenticated = true;
      localStorage.setItem("auth_token", token);
      addAuthToken(token);
    },
    clearToken: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem("auth_token");
      addAuthToken(null);
    },
  },
});

export const { setToken, clearToken } = authSlice.actions;
export default authSlice.reducer;
